import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';

@Component({
	standalone: false,

	selector: 'progress-line',
	templateUrl: './progress-line.component.html',
	styleUrls: ['./progress-line.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressLineComponent {
	@Input()
	public loading = false;

	/**
	 * Value in the interval `[0, 100]`.
	 */
	@Input()
	public value: number;
}

@NgModule({
	declarations: [ProgressLineComponent],
	imports: [CommonModule],
	exports: [ProgressLineComponent],
})
export class ProgressLineModule {}
